import { Navigate, Route, Routes } from "react-router-dom";

import PayinCreatePage from "./pages/PayinCreatePage";
import PayinReturnPage from "./pages/PayinReturnPage";

/**
 * Sub-router for `/app/payins/*`. The creation view IS the payins home: the legacy PHP-history list was
 * removed (runtime operations live in /app/payments-activity). `/result` is where the PSE bank flow sends the
 * payer back (the backend return callback appends ?payin=<id>). `/new` and the old per-country routes
 * redirect here so bookmarks and stale links keep working.
 */
export const PayinsNavigation = () => {
  return (
    <Routes>
      <Route path="/" element={<PayinCreatePage />} />
      <Route path="/result" element={<PayinReturnPage />} />
      <Route path="*" element={<Navigate to="/app/payins" replace />} />
    </Routes>
  );
};
